import MeetingFreeConsultModalService from '/@/modules/meeting/services/ui/MeetingFreeConsultModalService';

export const OpensFreeConsultModalMixin = {
  methods: {
    openFreeConsultModal(jurisdictionId) {
      MeetingFreeConsultModalService.show(
        this,
        jurisdictionId,
        {
          'on-meeting-scheduled': () => this.close()
        },
        {
          customClass: 'has-priority'
        }
      );
    }
  }
};
